import { render, staticRenderFns } from "./invoice-tabs.vue?vue&type=template&id=7031ada7&scoped=true&"
import script from "./invoice-tabs.ts?vue&type=script&lang=ts&"
export * from "./invoice-tabs.ts?vue&type=script&lang=ts&"
import style0 from "./invoice-tabs.scss?vue&type=style&index=0&id=7031ada7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7031ada7",
  null
  
)

export default component.exports